import { Button, Modal, Radio } from "@marketplace/ui";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlinePeople, MdPersonOutline } from "react-icons/md";

import { SellerTypeRadio } from "./seller-type-radio";

type SellerType = "internal" | "external";

type AddSellerTypeModalProps = {
  opened: boolean;
  onClose: () => void;
};

export const AddSellerTypeModal = ({
  opened,
  onClose
}: AddSellerTypeModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation("users");
  const { t: tCommon } = useTranslation("common");
  const [selectedType, setSelectedType] = useState<SellerType>("internal");

  const handleConfirm: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    onClose();
    navigate({
      to: "/users/sellers/create",
      search: {
        type: selectedType
      }
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("sellerListPage.addSellerTypeModal.title")}
      size={430}
    >
      <div className="mb-6">
        <Radio.Group
          value={selectedType}
          onChange={(value) => setSelectedType(value as SellerType)}
        >
          <div className="flex flex-col gap-y-[14px]">
            <SellerTypeRadio
              value="internal"
              title={t(
                "sellerListPage.addSellerTypeModal.types.internal.title"
              )}
              description={t(
                "sellerListPage.addSellerTypeModal.types.internal.description"
              )}
              icon={<MdPersonOutline size={40} />}
            />
            <SellerTypeRadio
              value="external"
              title={t(
                "sellerListPage.addSellerTypeModal.types.external.title"
              )}
              description={t(
                "sellerListPage.addSellerTypeModal.types.external.description"
              )}
              icon={<MdOutlinePeople size={40} />}
            />
          </div>
        </Radio.Group>
      </div>
      <div className="flex justify-end items-center gap-x-[14px]">
        <Button variant="secondary" className="w-[128px]" onClick={onClose}>
          {tCommon("cancel")}
        </Button>
        <Button variant="primary" className="w-[128px]" onClick={handleConfirm}>
          {tCommon("confirm")}
        </Button>
      </div>
    </Modal>
  );
};
